import { Box, Button, HStack, Text, useToast } from "@chakra-ui/react";
import React from "react";
import { FiCopy, FiShare2 } from "react-icons/fi";

/** „Podaj dalej" — link do zaproszenia innych (kopiuj + natywne udostępnianie). */
export const ShareInvite: React.FC<{ url: string }> = ({ url }) => {
  const toast = useToast();

  const copy = () => {
    navigator.clipboard?.writeText(url);
    toast({ title: "Skopiowano link", status: "success", duration: 1500, isClosable: true });
  };

  const share = () => {
    if (typeof navigator.share === "function") {
      navigator.share({ url }).catch(() => undefined);
    } else {
      copy();
    }
  };

  const canShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

  return (
    <Box mt="20px" pt="20px" borderTop="1px solid rgba(67,0,152,0.08)">
      <Text fontSize="14px" fontWeight="700" color="primary" mb="4px">
        Podaj dalej
      </Text>
      <Text fontSize="13px" color="gray.500" mb="13px" lineHeight="1.5">
        Udostępnij link, by zaprosić innych do zapisu.
      </Text>
      <HStack spacing="8px">
        <Box flex="1" minW={0} bg="#FAF8FE" border="1px solid rgba(67,0,152,0.1)" borderRadius="12px" px="13px" py="11px">
          <Text fontSize="13px" color="gray.600" noOfLines={1}>
            {url}
          </Text>
        </Box>
        <Button onClick={copy} leftIcon={<FiCopy />} variant="outline" borderColor="primary" color="primary" borderRadius="12px" fontWeight="700" px="16px" flexShrink={0} _hover={{ bg: "rgba(67,0,152,0.05)" }}>
          Kopiuj
        </Button>
        {canShare && (
          <Button onClick={share} bg="primary" color="white" borderRadius="12px" px="14px" flexShrink={0} _hover={{ bg: "#36007a" }}>
            <FiShare2 />
          </Button>
        )}
      </HStack>
    </Box>
  );
};
